export { default } from './BatteryMedium'
